import { handleErrors } from './ErrorActions';
import * as scormApi from '../api/scorm';
import { bulkUpdateFormDataWithRules } from '../form-designer/actions/runtime.actions';

const UPLOAD_SCORM_CONTENT = 'ScormActions/UPLOAD_SCORM_CONTENT';
const UPLOAD_SCORM_CONTENT_SUCCESS = 'ScormActions/UPLOAD_SCORM_CONTENT_SUCCESS';
const UPLOAD_SCORM_CONTENT_FAILED = 'ScormActions/UPLOAD_SCORM_CONTENT_FAILED';
const SCORM_USER_REGISTRATION = 'ScormActions/SCORM_USER_REGISTRATION';
const SCORM_USER_REGISTRATION_SUCCESS = 'ScormActions/SCORM_USER_REGISTRATION_SUCCESS';
const SCORM_USER_REGISTRATION_FAILED = 'ScormActions/SCORM_USER_REGISTRATION_FAILED';
const SCORM_LAUNCH_PREVIEW = 'ScormActions/SCORM_LAUNCH_PREVIEW';
const SCORM_LAUNCH_PREVIEW_SUCCESS = 'ScormActions/SCORM_LAUNCH_PREVIEW_SUCCESS';
const SCORM_LAUNCH_PREVIEW_FAILED = 'ScormActions/SCORM_LAUNCH_PREVIEW_FAILED';

export const TITLE_PATH = [
  'DTI_SCORM_COURSE_TITLE',
  'DTI_SCORM_REF_CUR_TITLE',
  'DTI_SCORM_REV_CUR_TITLE',
];

const VERSION_PATH = [
  'DTI_SCORM_COURSE_VERSION',
  'DTI_SCORM_REF_CUR_VERSION',
  'DTI_SCORM_REV_CUR_VERSION',
];

export function uploadScormContent(data) {
  return async (dispatch) => {
    dispatch({
      type: UPLOAD_SCORM_CONTENT,
      payload: {
        data,
      },
    });

    try {
      const { data: apiData } = await scormApi.uploadScormContent(data);

      if (apiData.hasError) {
        dispatch(handleErrors(apiData.errors, { isTopBanner: apiData.isTopBanner }));
        dispatch({
          type: UPLOAD_SCORM_CONTENT_FAILED,
        });

        return;
      }

      dispatch({
        type: UPLOAD_SCORM_CONTENT_SUCCESS,
        payload: apiData,
      });

      return Promise.resolve(apiData);
    } catch (error) {
      dispatch(handleErrors(error));

      dispatch({
        type: UPLOAD_SCORM_CONTENT_FAILED,
      });

      return Promise.reject(error);
    }
  };
}

export function userRegistration(data) {
  return async (dispatch) => {
    dispatch({
      type: SCORM_USER_REGISTRATION,
      payload: {
        data,
      },
    });

    try {
      const { data: apiData } = await scormApi.createScormUserRegistration(data);

      if (!apiData) {
        throw Error('Internal error');
      }
      if (apiData.hasError) {
        throw apiData.errors;
      }

      dispatch({
        type: SCORM_USER_REGISTRATION_SUCCESS,
        payload: apiData,
      });

      return apiData;
    } catch (error) {
      dispatch(handleErrors(error));

      dispatch({
        type: SCORM_USER_REGISTRATION_FAILED,
        error,
      });

      return Promise.reject(error);
    }
  };
}

export function launchPreview(data) {
  return async (dispatch) => {
    dispatch({
      type: SCORM_LAUNCH_PREVIEW,
      payload: {
        data,
      },
    });

    try {
      const { data: apiData } = await scormApi.launchPreview(data);

      if (!apiData) {
        throw Error('Internal error');
      }
      if (apiData.hasError) {
        throw apiData.errors;
      }

      dispatch({
        type: SCORM_LAUNCH_PREVIEW_SUCCESS,
        payload: apiData,
      });

      return apiData;
    } catch (error) {
      dispatch(handleErrors(error));

      dispatch({
        type: SCORM_LAUNCH_PREVIEW_FAILED,
        error,
      });

      return Promise.reject(error);
    }
  };
}

export const setCourse = (title, version, certificationType, formKey) => (dispatch) => {
  const changesToApply = [
    {
      entityName: 'V_CUR_COURSE-V_DTI_DUT_TRAINING_INFO',
      fieldName: TITLE_PATH[certificationType],
      index: [0],
      value: title,
    },
    {
      entityName: 'V_CUR_COURSE-V_DTI_DUT_TRAINING_INFO',
      fieldName: VERSION_PATH[certificationType],
      index: [0],
      value: version,
    },
  ];

  dispatch(bulkUpdateFormDataWithRules(changesToApply, formKey));
};
